<template>
    <div class="consultaion">
        <div>
            <div style="padding-bottom:20px;color: #999999;">
                <span class="head_style">当前位置：</span>
                <router-link to="/" class="head_style">首页</router-link> >
                <router-link to="/consultation-list" class="head_style">版权新闻</router-link> >
                <span class="head_style">{{title}}</span>
            </div>
            <div class="box-style">
                <h1 class="list_new_title">{{title}}</h1>
                <div style="text-align: center;margin-top:10px">发表时间 ：{{fbTime}}</div>
                <div class="list-left" v-html="content" style="line-height: 2;">
                    {{content}}
                </div>
            </div>
            <div class="list-left-bottom">
                <span @click="upArticleId" v-if="upArticle">上一篇：{{upArticle}}</span>
                <span @click="downArticleId" style="text-align:right" v-if="downArticle">下一篇：{{downArticle}}</span>
            </div>
        </div>
        <div class="list-right">
            <div class="list-right-top">
                <div class="list-title">
                    <span style="margin-left:20px">相关推荐</span>
                </div>
                <ul class="list-right-ul">
                    <li v-for="(item,index) in messageList" :key="index" @click="updataRecommend(item.id)"><span>{{item.title}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import merge from 'webpack-merge';
    import {_turningArticle} from '@/api/consultation'

    export default {
        metaInfo() {
            return {
                title: this.title + '|版权服务专家|版权家',
                meta: [{                 // set meta
                    name: 'keyWords',
                    content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
                }, {
                    name: 'Description',
                    content: '版权信息,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
                }]
            }
        },
        name: "consultationInfo",
        data() {
            return {
                content: "",
                messageList: [],
                upArticle: "",
                upArticleIds: "",
                downArticle: "",
                downArticleIds: "",
                title: "",
                fbTime:""
            }
        },
        methods: {
            getArticles(id) {
                // console.log(this.$route)
                this.getRequest('/cmsArticle/getArticle/' + id).then(res => {
                    if (res.code == 200) {
                        this.title = res.result.title;
                        this.content = res.result.content.content;
                        this.messageList = res.result.recommends;
                        this.upArticle = res.result.upArticle && res.result.upArticle.title;
                        this.upArticleIds = res.result.upArticle && res.result.upArticle.id;
                        this.downArticle = res.result.downArticle && res.result.downArticle.title;
                        this.downArticleIds = res.result.downArticle && res.result.downArticle.id;
                        this.fbTime = res.result.createDate;
                        this.turningArticle(id)

                    }
                })
            },
            // 更新页面
            // updatePages(val){
            //   this.$router.push({query:merge(this.$route.query,{'newPage':val})})
            //   // console.log(this.$route)
            //   const newId = this.$route.query.newPage;
            //   this.getArticles(newId);
            // },
            //相关推荐
            updataRecommend(val) {
                //  this.updatePages(val)
                this.$router.push({name:'consultationInfo',params:{id:val}});
                // this.getArticles(val)
            },
            //上一篇
            upArticleId() {
                // this.updatePages(this.upArticleIds)
                this.getArticles(this.upArticleIds)
            },
            //下一篇
            downArticleId() {
                this.getArticles(this.downArticleIds)
                // this.updatePages(this.downArticleIds)
            },

            //上下篇数据文章标题获取
            turningArticle(id) {
                let data = {
                    id: id,
                    type: 'down'
                }
                _turningArticle(data).then(res => {
                  console.log(res);
                })
            }

        },
        watch: {
            $route(to, from) {
                console.log('+++++++++++++++++++++', to, from)
                this.getArticles(this.$route.params.id);
            }
        },
        beforeCreate(){
            console.log(this.$route.params.id)
        },
        mounted() {
            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
                console.log(window.location.href)
                window.location.href="https://m.bqj.cn/pages/dynamic/dynamicDetail?id="+ this.$route.params.id;
            }
            console.log(this.$route.params.id)
            if (this.$route.query.newPage) {
                this.getArticles(this.$route.query.newPage);
            } else {
                this.getArticles(this.$route.params.id);
            }
        },
    };
</script>

<style scoped lang="less">
    .consultaion {
        width: 1334px;
        display: flex;
        justify-content: space-between;
        margin: 20px auto 50px;
        .head_style{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
        }
        .box-style{
            width:890px;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
            border-radius:2px;
        }
        .list_new_title {
            width: 830px;
            margin:0 auto;
            text-align: center;
            // line-height: 50px;
            font-size: 28px;
            font-weight: 600;
            color:#333;
            padding-top:50px;
            // box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            // border-radius: 2px 2px 0px 0px;
            // background: #fff;
            
        }

        .list-left {
            width: 830px;
            min-height: 600px;
            // background: rgba(255, 255, 255, 1);
            // box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            // border-radius: 0px 0px 2px 2px;
            margin:0 auto 20px;
            /deep/ img {
                max-width: 830px !important;
                margin: 0 auto;
                display: flex;
            }
            // /deep/ p {
            //   font-size: 16px;
            //   color: #666;
            // }
            // /deep/ span {
            //   font-size: 16px;
            //   color: #666;
            // }
        }

        .list-left-bottom {
            width: 890px;
            height: 72px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            border-radius: 2px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
                font-size: 16px;
                color: rgba(102, 102, 102, 1);
                margin: 0px 30px;
                display: inline-block;
                width: 385px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
            }
        }

        .list-right {
            width: 424px;
            height: 835px;

            .list-right-top {
                width: 424px;
                height: 613px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
                border-radius: 2px;
                margin-bottom: 20px;

                .list-title {
                    width: 424px;
                    height: 62px;
                    line-height: 62px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 2px 2px 0px 0px;
                    font-size: 16px;
                    color: rgba(51, 51, 51, 1);
                    border-bottom: 1px solid #EEEEEE;
                }

                .list-right-ul {
                    overflow: hidden;
                    height: 489px;

                    li {
                        list-style: none;
                        height: 60px;
                        width: 404px;
                        line-height: 60px;
                        font-size: 14px;
                        color: rgba(102, 102, 102, 1);
                        margin-left: 20px;
                        border-bottom: 1px solid #EEEEEE;
                        cursor: pointer;

                        span {
                            display: inline-block;
                            width: 394px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }
</style>
